// src/hooks/hotelRoomCategories/useRestoreAllHotelRoomCategories.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllHotelRoomCategories as restoreAllHotelRoomCategoriesAPI } from "../../api/apiHotelRoomCategories";
import parseError from "../../utils/parseError";

const useRestoreAllHotelRoomCategories = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreAll, isPending: isRestoreAll } = useMutation({
        mutationFn: restoreAllHotelRoomCategoriesAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected hotel room categories restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelRoomCategories"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore selected hotel room categories");
        },
    });

    return { restoreAllHotelRoomCategories: restoreAll, isRestoreAll };
};

export default useRestoreAllHotelRoomCategories;
